import React from 'react';

import usePaths from 'src/hooks/use-paths';

import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

import { ADS_FETCH_POLICY } from 'src/utils/ads/helpers';
import { AdInventoryId, useGetSponsoredBrandQuery } from 'types/graphql';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useSponsoredBrandProductsV2 } from '../shared/use-sponsored-brand-products-v2';

export const HomePageSponsoredBrandCarousel = (): JSX.Element | null => {
  const { href } = usePaths({ brands: true });
  const { dispensary } = useDispensary();

  const sponsoredBrandQuery = useGetSponsoredBrandQuery({
    fetchPolicy: ADS_FETCH_POLICY,
    variables: {
      input: {
        dispensaryId: dispensary.id,
        inventoryId: AdInventoryId.homeCarouselAuc,
        minimumProducts: 3,
      },
    },
  });

  const {
    error,
    loading,
    products,
    handleProductClick,
    handleQuickAddToCart,
    handleViewAllClick,
    viewportVisibility,
    handleProductImpression,
    brandSlug,
  } = useSponsoredBrandProductsV2({ sponsoredBrandQuery, adPlacement: 'home.carousel' });

  if (!products.length || error) {
    return null;
  }

  if (!brandSlug) {
    console.error('missing brandSlug');
    return null;
  }

  const brandHref = `${href}/${brandSlug}`;

  return (
    <ProductCarousel
      hideSponsoredTag
      href={brandHref}
      isBottomSubTitle
      isLoading={loading}
      onProductClick={handleProductClick}
      onProductView={handleProductImpression}
      onQuickAddToCart={handleQuickAddToCart}
      onViewAllClick={handleViewAllClick}
      products={products}
      ref={viewportVisibility.ref}
      subTitle='Sponsored'
      title='Featured Brand'
    />
  );
};
